export const SINGLE_APP_QUICK_LINKS: QuickLinks = {
	title: 'app.yourApps.single.quickLinks.title',
	cards: [
		{
			icon: 'CreativeCloud',
			title: 'app.yourApps.single.application.title',
			desc: 'app.yourApps.single.application.desc',
			link: '/apps',
			hypertext: 'app.yourApps.single.application.hypertext',
			name: 'apps',
			iconColor: 'red-400',
			isNew: false,
		},
		{
			icon: 'Education',
			title: 'app.yourApps.single.learning.title',
			desc: 'app.yourApps.single.learning.desc',
			link: '/learn/app',
			hypertext: 'app.yourApps.single.learning.hypertext',
			name: 'learn',
			iconColor: 'seafoam-400',
			isNew: false,
		},
		{
			icon: 'Download',
			title: 'app.yourApps.single.issue.title',
			desc: 'app.yourApps.single.issue.desc',
			link: 'https://helpx.adobe.com/download-install.html',
			hypertext: 'app.yourApps.single.issue.hypertext',
			name: 'help-download',
			iconColor: 'indigo-400',
			isNew: false,
		},
		{
			icon: 'Apps',
			title: 'app.yourApps.single.more.title',
			desc: 'app.yourApps.single.more.desc',
			link: 'https://helpx.adobe.com/download-install/kb/download-availability.html',
			hypertext: 'app.yourApps.single.more.hypertext',
			name: 'help-more-apps',
			iconColor: 'celery-400',
			isNew: false,
		},
	],
};
export const COMM_QUICK_LINKS = {
	title: 'app.yourApps.single.quickLinks.title',
	cards: [
		{
			icon: 'CCLibrary',
			title: 'app.yourApps.quickLinks.cclibrary.title',
			desc: 'app.yourApps.quickLinks.comm.cclibrary.desc',
			link: 'https://helpx.adobe.com/creative-cloud/help/libraries-addin-microsoft-office.html',
			linkStage: 'https://helpx.stage.adobe.com/creative-cloud/help/libraries-addin-microsoft-office.html',
			hypertext: 'app.learnmore',
			name: 'cclibrary',
			iconColor: 'black',
			isNew: false,
		},
		{
			icon: 'Spark',
			title: 'app.yourApps.quickLinks.spark.title',
			desc: 'app.yourApps.quickLinks.spark.desc',
			link: 'https://youtu.be/BH0svIJX53A',
			hypertext: 'app.seehow',
			name: 'spark',
			iconColor: '',
			isNew: false,
		},
		{
			icon: 'Rush',
			title: 'app.yourApps.quickLinks.rush.title',
			desc: 'app.yourApps.quickLinks.rush.desc',
			link: 'https://www.youtube.com/watch?v=nreAZ9F_2l0&feature=youtu.be',
			hypertext: 'app.seehow',
			name: 'rush',
			iconColor: 'seafoam-400',
			isNew: false,
		},
		{
			icon: 'Stock',
			title: 'app.yourApps.quickLinks.stock.title',
			desc: 'app.yourApps.quickLinks.comm.stock.desc',
			link: 'https://www.youtube.com/watch?v=aWWnhxK62P4&list=PLD8AMy73ZVxUE53KQ4XLzXsr4u8txeX9d&index=56',
			hypertext: 'app.seehow',
			name: 'stock',
			iconColor: 'gray-800',
			isNew: false,
		},
	],
};

export const LIBRARIES_QUICK_LINKS: QuickLinks = {
	title: 'app.yourApps.single.quickLinks.title',
	cards: [
		{
			icon: 'CCLibrary',
			title: 'app.yourApps.quickLinks.cclibrary.title',
			desc: 'app.yourApps.quickLinks.cclibrary.desc',
			link: '/cc/libraries?x-product=CCHome&x-product-location=recocard',
			hypertext: 'app.yourApps.quickLinks.cclibrary.hypertext',
			name: 'cclibrary',
			iconColor: 'indigo-400',
			isNew: true,
		},
		{
			icon: 'Discover',
			title: 'app.yourApps.quickLinks.discover.title',
			desc: 'app.yourApps.quickLinks.discover.desc',
			link: '/cc/discover',
			hypertext: 'app.yourApps.quickLinks.discover.hypertext',
			name: 'discover',
			iconColor: 'yellow-400',
			isNew: false,
		},
		{
			icon: 'Stock',
			title: 'app.yourApps.quickLinks.stock.title',
			desc: 'app.yourApps.quickLinks.stock.desc',
			link: 'https://stock.adobe.com',
			hypertext: 'app.yourApps.quickLinks.stock.hypertext',
			name: 'stock',
			iconColor: 'gray-800',
			isNew: false,
		},
		{
			icon: 'Fonts',
			title: 'app.yourApps.quickLinks.fonts.title',
			desc: 'app.yourApps.quickLinks.fonts.desc',
			link: 'https://fonts.adobe.com',
			hypertext: 'app.yourApps.quickLinks.fonts.hypertext',
			name: 'fonts',
			iconColor: 'seafoam-400',
			isNew: false,
		},
	],
};

export const ACROBAT_DC_APP_QUICK_LINKS: QuickLinks = {
	title: 'app.yourApps.single.quickLinks.title',
	cards: [
		{
			icon: 'CreativeCloud',
			title: 'app.yourApps.single.application.title',
			desc: 'app.yourApps.single.application.desc',
			link: '/apps',
			hypertext: 'app.yourApps.single.application.hypertext',
			name: 'apps',
			iconColor: 'red-400',
			isNew: false,
		},
		{
			icon: 'CreatePDF',
			title: 'app.yourApps.acrobat.documentCloud.title',
			desc: 'app.yourApps.acrobat.createPDF.desc',
			link: 'https://documentcloud.adobe.com/link/home/?dialog!dropin=createpdf',
			hypertext: 'app.yourApps.acrobat.createPDF.hypertext',
			name: 'pdf-create',
			iconColor: 'red-400',
			isNew: false,
		},
		{
			icon: 'CombinePDF',
			title: 'app.yourApps.acrobat.documentCloud.title',
			desc: 'app.yourApps.acrobat.combinePDF.desc',
			link: 'https://documentcloud.adobe.com/link/combinepdf/',
			hypertext: 'app.yourApps.acrobat.combinePDF.hypertext',
			name: 'pdf-combine',
			iconColor: 'celery-400',
			isNew: false,
		},
		{
			icon: 'ExportPDF',
			title: 'app.yourApps.acrobat.documentCloud.title',
			desc: 'app.yourApps.acrobat.exportPDF.desc',
			link: 'https://documentcloud.adobe.com/link/home/?dialog!dropin=exportpdf',
			hypertext: 'app.yourApps.acrobat.exportPDF.hypertext',
			name: 'pdf-export',
			iconColor: 'chartreuse-400',
			isNew: false,
		},
	],
};
